module.exports = __webpack_public_path__ + "static/media/sample_08.518de254.jpg";